import { render } from "./AIChatMessages.vue?vue&type=template&id=4509818c&scoped=true"
import script from "./AIChatMessages.vue?vue&type=script&lang=js"
export * from "./AIChatMessages.vue?vue&type=script&lang=js"

import "./AIChatMessages.vue?vue&type=style&index=0&id=4509818c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4509818c"]])

export default __exports__